import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Card from "../../components/Card";
import '../../styles/Quebec.css'
import { Drawer, TextField, MenuItem, Box, Button } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";


export default function Quebec({ dark, setDark }) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const toggleTheme = () => setDark(!dark);
    const navigate = useNavigate();
    const [selected, setSelected] = useState(null);
    const [notes, setNotes] = useState("");
    const [items, setItems] = useState([]);
    const [openLogementDrawer, setOpenLogementDrawer] = useState(false);
    const [openEmploiDrawer, setOpenEmploiDrawer] = useState(false);
    const [openEcoleDrawer, setOpenEcoleDrawer] = useState(false);
    const [openSanteDrawer, setOpenSanteDrawer] = useState(false);
    const [ecoleStep, setEcoleStep] = useState(1);
    const [santeStep, setSanteStep] = useState(1);
    const [logementStep, setLogementStep] = useState(1);
    const [emploiStep, setEmploiStep] = useState(1);
    const [logementForm, setLogementForm] = useState({
        loyer: "",
        ville: "",
        type: "Appartement",
        notes: ""
    });
    const [emploiForm, setEmploiForm] = useState({
        poste: "",
        ville: "",
        sites: "",
        notes: ""
    });
    const [ecoleForm, setEcoleForm] = useState({
        ages: "",
        type: "École primaire",
        ville: "",
        notes: ""
    });
    const [santeForm, setSanteForm] = useState({
        assurance: "",
        besoins: "",
        clinique: "",
        notes: ""
    });

    const theme = createTheme({
        palette: {
            mode: dark ? "dark" : "light",
            primary: {
                main: "#6fb8af"
            }
        }
    });

    useEffect(() => {
        const saved = localStorage.getItem("notes_quebec");
        if (saved) setNotes(saved);
    }, []);



    const [timeline, setTimeline] = useState([
        {
            title: "Passeports mis à jour",
            date: "Janvier 2024",
            status: "done",
            tag: "administratif",
            description: "Renouvellement des passeports pour toute la famille."
        },
        {
            title: "Évaluation comparative des études",
            date: "En cours",
            status: "progress",
            tag: "administratif",
            description: "Dossier envoyé au ministère de l'immigration du Québec."
        },
        {
            title: "Demande CSQ",
            date: "Prévue : Avril 2025",
            status: "todo",
            tag: "administratif",
            description: "Préparation des documents nécessaires."
        },
        {
            title: "Recherche de logement",
            date: "À faire",
            status: "todo",
            tag: "logement",
            description: "Regarder Montréal, Québec, Sherbrooke."
        },
        {
            title: "Trouver un emploi",
            date: "À faire",
            status: "todo",
            tag: "emploi",
            description: "Chercher dans l'informatique et le support technique."
        }
    ]);
    const [budget, setBudget] = useState({
        fraisAdmin: 0,
        billets: 0,
        logement: 0,
        caution: 0,
        assurance: 0,
        installation: 0,
        fondsExiges: 0
    });

    const totalBudget =
        Number(budget.fraisAdmin) +
        Number(budget.billets) +
        Number(budget.logement) +
        Number(budget.caution) +
        Number(budget.assurance) +
        Number(budget.installation) +
        Number(budget.fondsExiges);


    const completed = timeline.filter(t => t.status === "done").length;
    const total = timeline.length;
    const percent = Math.round((completed / total) * 100);

    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

            <div className="main">
                <Topbar
                    onToggleSidebar={() => setSidebarOpen(true)}
                    onToggleTheme={toggleTheme}
                    dark={dark}
                />

                <div className="content">

                    {/* --- HEADER --- */}
                    <div className="header-block">

                        <div className="header-left">
                            <h1>🇨🇦 Projet Québec</h1>
                            <p>
                                Toutes les informations, démarches et ressources pour préparer notre immigration au
                                Québec.
                            </p>
                        </div>

                        <div className="header-actions">
                            <button
                                className="action-btn"
                                onClick={() => navigate("/quebec/notes")}
                            >
                                Notes
                            </button>

                            <button className="action-btn" onClick={() => setOpenLogementDrawer(true)}>
                                Ajouter un logement
                            </button>

                            <button className="action-btn" onClick={() => setOpenEmploiDrawer(true)}>
                                Ajouter un emploi
                            </button>

                            <button className="action-btn" onClick={() => setOpenEcoleDrawer(true)}>
                                Ajouter une école
                            </button>

                            <button className="action-btn" onClick={() => setOpenSanteDrawer(true)}>
                                Ajouter une info santé
                            </button>
                        </div>

                    </div>


                    {/* --- CARDS --- */}
                    <div className="cards">
                        <Card
                            title="Démarches complétées"
                            value={completed + " / " + total}
                            sub="Progression du projet."
                            chip={percent + "% complété"}
                        />
                        <Card
                            title="Documents prêts"
                            value="8"
                            sub="Documents déjà rassemblés."
                        />
                        <Card
                            title="Rendez-vous"
                            value="2"
                            sub="À venir ce mois-ci."
                        />
                        <Card
                            title="Budget"
                            value="7 500 $"
                            sub="Économies dédiées au projet."
                        />
                    </div>

                    {/* --- LAYOUT 2 COLS --- */}
                    <div className="layout-two-cols">

                        {/* --- CHECKLIST --- */}
                        <div className="card-block">
                            <h2>Checklist administrative</h2>

                            <ul className="checklist">
                                <li><input type="checkbox"/> Passeports à jour</li>
                                <li><input type="checkbox"/> Évaluation comparative des études</li>
                                <li><input type="checkbox"/> Certificat de sélection du Québec (CSQ)</li>
                                <li><input type="checkbox"/> Dossier Entrée Express</li>
                                <li><input type="checkbox"/> Preuve de fonds</li>
                                <li><input type="checkbox"/> Assurance santé temporaire</li>
                                <li><input type="checkbox"/> Recherche de logement</li>
                            </ul>
                        </div>

                        {/* --- RESSOURCES --- */}
                        <div className="card-block">
                            <h2>Ressources utiles</h2>

                            <div className="resource-list">
                                <a href="https://www.quebec.ca/immigration" target="_blank">Site officiel Immigration
                                    Québec</a>
                                <a href="https://www.canada.ca/fr/immigration-refugies-citoyennete.html"
                                   target="_blank">IRCC – Canada</a>
                                <a href="https://www.quebec.ca/emploi" target="_blank">Trouver un emploi au Québec</a>
                                <a href="https://www.kijiji.ca/" target="_blank">Kijiji – Logements</a>
                                <a href="https://www.desjardins.com/" target="_blank">Banques (Desjardins)</a>
                            </div>
                        </div>
                    </div>

                    {/* --- NOTES --- */}
                    {/*<div className="card-block" style={{marginTop: "30px"}}>*/}
                    {/*    <h2>Notes & Astuces</h2>*/}

                    {/*    <textarea*/}
                    {/*        className="notes-textarea"*/}
                    {/*        placeholder="Écris ici toutes tes notes, idées, astuces, contacts, etc."*/}
                    {/*        value={notes}*/}
                    {/*        onChange={(e) => {*/}
                    {/*            setNotes(e.target.value);*/}
                    {/*            localStorage.setItem("notes_quebec", e.target.value);*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</div>*/}


                    {/* --- Calculateur Budget --- */}

                    <div className="card-block" style={{marginTop: "30px"}}>
                        <h2>Budget</h2>

                        <div className="budget-grid">

                            <div className="budget-item">
                                <label>Frais administratifs</label>
                                <input
                                    type="number"
                                    value={budget.fraisAdmin}
                                    onChange={(e) => setBudget({...budget, fraisAdmin: e.target.value})}
                                />
                            </div>

                            <div className="budget-item">
                                <label>Billets d’avion</label>
                                <input
                                    type="number"
                                    value={budget.billets}
                                    onChange={(e) => setBudget({...budget, billets: e.target.value})}
                                />
                            </div>

                            <div className="budget-item">
                                <label>Logement (1er mois)</label>
                                <input
                                    type="number"
                                    value={budget.logement}
                                    onChange={(e) => setBudget({...budget, logement: e.target.value})}
                                />
                            </div>

                            <div className="budget-item">
                                <label>Caution logement</label>
                                <input
                                    type="number"
                                    value={budget.caution}
                                    onChange={(e) => setBudget({...budget, caution: e.target.value})}
                                />
                            </div>

                            <div className="budget-item">
                                <label>Assurance santé</label>
                                <input
                                    type="number"
                                    value={budget.assurance}
                                    onChange={(e) => setBudget({...budget, assurance: e.target.value})}
                                />
                            </div>

                            <div className="budget-item">
                                <label>Installation / Meubles</label>
                                <input
                                    type="number"
                                    value={budget.installation}
                                    onChange={(e) => setBudget({...budget, installation: e.target.value})}
                                />
                            </div>

                            <div className="budget-item">
                                <label>Fonds exigés par le Canada</label>
                                <input
                                    type="number"
                                    value={budget.fondsExiges}
                                    onChange={(e) => setBudget({...budget, fondsExiges: e.target.value})}
                                />
                            </div>

                        </div>

                        <div className="budget-total">
                            <h3>Total estimé : <span>{totalBudget.toLocaleString()} $</span></h3>
                        </div>
                    </div>

                    {/* --- Tableau de suivi --- */}
                    <div className="card-block" style={{marginTop: "30px"}}>
                        <h2>Tableau de suivi</h2>

                        <div className="items-grid">
                            {items.length === 0 && <p>Aucun élément pour le moment.</p>}

                            {items.map(item => (
                                <div key={item.id} className={`item-card item-${item.type}`}>
                                    <h3>{item.title}</h3>
                                    <span className="tag">{item.type}</span>
                                    <p>{item.details}</p>
                                </div>
                            ))}
                        </div>
                    </div>


                    {/* --- TIMELINE --- */}
                    <div className="card-block" style={{marginTop: "30px"}}>
                        <h2>Progression du projet</h2>

                        <div className="progress-wrapper">
                            <div className="progress-bar">
                                <div className="progress-fill" style={{width: percent + "%"}}></div>
                            </div>

                            <p className="progress-text">{percent}% complété</p>
                        </div>
                    </div>


                    <div className="card-block" style={{marginTop: "30px"}}>
                        <h2>Timeline des démarches</h2>

                        <div className="timeline">
                            {timeline.map((item, index) => (
                                <div
                                    key={index}
                                    className={`timeline-item ${item.status}`}
                                    onClick={() => setSelected(item)}
                                >
                                    <div className="timeline-dot"></div>

                                    <div className="timeline-content">
                                        <h3>{item.title}</h3>
                                        <p className="date">{item.date}</p>
                                        <span className={`tag tag-${item.tag}`}>{item.tag}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {selected && (
                        <div className="modal-overlay" onClick={() => setSelected(null)}>
                            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                                <h2>{selected.title}</h2>
                                <p><strong>Date :</strong> {selected.date}</p>
                                <p><strong>Statut :</strong> {selected.status}</p>
                                <p style={{marginTop: "15px"}}>{selected.description}</p>
                                <p><strong>Catégorie :</strong> <span
                                    className={`tag tag-${selected.tag}`}>{selected.tag}</span></p>


                                <button className="close-btn" onClick={() => setSelected(null)}>
                                    Fermer
                                </button>
                            </div>
                        </div>
                    )}


                </div>
            </div>
            <ThemeProvider theme={theme}>
                <Drawer
                    anchor="right"
                    open={openSanteDrawer}
                    onClose={() => {
                        setOpenSanteDrawer(false);
                        setSanteStep(1);
                    }}
                >
                    <Box
                        sx={{
                            width: "60vw",
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                        }}
                    >
                        <h2>Ajouter une info santé</h2>

                        {/* ÉTAPE 1 */}
                        {santeStep === 1 && (
                            <>
                                <TextField
                                    label="Assurance santé prévue"
                                    fullWidth
                                    value={santeForm.assurance}
                                    onChange={(e) =>
                                        setSanteForm({...santeForm, assurance: e.target.value})
                                    }
                                />

                                <Button variant="contained" onClick={() => setSanteStep(2)}>
                                    Suivant
                                </Button>
                            </>
                        )}

                        {/* ÉTAPE 2 */}
                        {santeStep === 2 && (
                            <>
                                <TextField
                                    label="Besoins médicaux particuliers"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    value={santeForm.besoins}
                                    onChange={(e) =>
                                        setSanteForm({...santeForm, besoins: e.target.value})
                                    }
                                />

                                <Box sx={{display: "flex", gap: 1}}>
                                    <Button variant="outlined" onClick={() => setSanteStep(1)}>
                                        Retour
                                    </Button>
                                    <Button variant="contained" onClick={() => setSanteStep(3)}>
                                        Suivant
                                    </Button>
                                </Box>
                            </>
                        )}

                        {/* ÉTAPE 3 */}
                        {santeStep === 3 && (
                            <>
                                <TextField
                                    label="Clinique / Hôpital ciblé"
                                    fullWidth
                                    value={santeForm.clinique}
                                    onChange={(e) =>
                                        setSanteForm({ ...santeForm, clinique: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setSanteStep(2)}>
                                        Retour
                                    </Button>
                                    <Button variant="contained" onClick={() => setSanteStep(4)}>
                                        Suivant
                                    </Button>
                                </Box>
                            </>
                        )}

                        {/* ÉTAPE 4 */}
                        {santeStep === 4 && (
                            <>
                                <TextField
                                    label="Notes"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    value={santeForm.notes}
                                    onChange={(e) =>
                                        setSanteForm({ ...santeForm, notes: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setSanteStep(3)}>
                                        Retour
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={() => {
                                            setItems([
                                                ...items,
                                                {
                                                    id: Date.now(),
                                                    type: "sante",
                                                    title: santeForm.assurance || "Information santé",
                                                    details: `Clinique : ${santeForm.clinique}\nBesoins : ${santeForm.besoins}\n${santeForm.notes}`,
                                                },
                                            ]);

                                            setSanteForm({
                                                assurance: "",
                                                besoins: "",
                                                clinique: "",
                                                notes: "",
                                            });

                                            setSanteStep(1);
                                            setOpenSanteDrawer(false);
                                        }}
                                    >
                                        Ajouter
                                    </Button>
                                </Box>
                            </>
                        )}
                    </Box>
                </Drawer>
            </ThemeProvider>

            <ThemeProvider theme={theme}>
                <Drawer
                    anchor="right"
                    open={openEcoleDrawer}
                    onClose={() => {
                        setOpenEcoleDrawer(false);
                        setEcoleStep(1);
                    }}
                >
                    <Box
                        sx={{
                            width: "60vw",
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                        }}
                    >
                        <h2>Ajouter une école</h2>

                        {/* ÉTAPE 1 */}
                        {ecoleStep === 1 && (
                            <>
                                <TextField
                                    label="Âge des enfants"
                                    fullWidth
                                    value={ecoleForm.ages}
                                    onChange={(e) =>
                                        setEcoleForm({ ...ecoleForm, ages: e.target.value })
                                    }
                                />

                                <Button variant="contained" onClick={() => setEcoleStep(2)}>
                                    Suivant
                                </Button>
                            </>
                        )}

                        {/* ÉTAPE 2 */}
                        {ecoleStep === 2 && (
                            <>
                                <TextField
                                    label="Type d’établissement"
                                    select
                                    fullWidth
                                    value={ecoleForm.type}
                                    onChange={(e) =>
                                        setEcoleForm({ ...ecoleForm, type: e.target.value })
                                    }
                                >
                                    <MenuItem value="École primaire">École primaire</MenuItem>
                                    <MenuItem value="École secondaire">École secondaire</MenuItem>
                                    <MenuItem value="Cégep">Cégep</MenuItem>
                                    <MenuItem value="Université">Université</MenuItem>
                                </TextField>

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setEcoleStep(1)}>
                                        Retour
                                    </Button>
                                    <Button variant="contained" onClick={() => setEcoleStep(3)}>
                                        Suivant
                                    </Button>
                                </Box>
                            </>
                        )}

                        {/* ÉTAPE 3 */}
                        {ecoleStep === 3 && (
                            <>
                                <TextField
                                    label="Ville / Quartier ciblé"
                                    fullWidth
                                    value={ecoleForm.ville}
                                    onChange={(e) =>
                                        setEcoleForm({ ...ecoleForm, ville: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setEcoleStep(2)}>
                                        Retour
                                    </Button>
                                    <Button variant="contained" onClick={() => setEcoleStep(4)}>
                                        Suivant
                                    </Button>
                                </Box>
                            </>
                        )}

                        {/* ÉTAPE 4 */}
                        {ecoleStep === 4 && (
                            <>
                                <TextField
                                    label="Notes"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    value={ecoleForm.notes}
                                    onChange={(e) =>
                                        setEcoleForm({ ...ecoleForm, notes: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setEcoleStep(3)}>
                                        Retour
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={() => {
                                            setItems([
                                                ...items,
                                                {
                                                    id: Date.now(),
                                                    type: "ecole",
                                                    title: `${ecoleForm.type} - ${ecoleForm.ville}`,
                                                    details: `Âges : ${ecoleForm.ages}\n${ecoleForm.notes}`,
                                                },
                                            ]);

                                            setEcoleForm({
                                                ages: "",
                                                type: "École primaire",
                                                ville: "",
                                                notes: "",
                                            });

                                            setEcoleStep(1);
                                            setOpenEcoleDrawer(false);
                                        }}
                                    >
                                        Ajouter
                                    </Button>
                                </Box>
                            </>
                        )}
                    </Box>
                </Drawer>
            </ThemeProvider>

            <ThemeProvider theme={theme}>
                <Drawer
                    anchor="right"
                    open={openEmploiDrawer}
                    onClose={() => {
                        setOpenEmploiDrawer(false);
                        setEmploiStep(1);
                    }}
                >
                    <Box
                        sx={{
                            width: "60vw",
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                        }}
                    >
                        <h2>Ajouter un emploi</h2>

                        {/* ÉTAPE 1 */}
                        {emploiStep === 1 && (
                            <>
                                <TextField
                                    label="Poste recherché"
                                    fullWidth
                                    value={emploiForm.poste}
                                    onChange={(e) =>
                                        setEmploiForm({ ...emploiForm, poste: e.target.value })
                                    }
                                />

                                <Button variant="contained" onClick={() => setEmploiStep(2)}>
                                    Suivant
                                </Button>
                            </>
                        )}

                        {/* ÉTAPE 2 */}
                        {emploiStep === 2 && (
                            <>
                                <TextField
                                    label="Ville ciblée"
                                    fullWidth
                                    value={emploiForm.ville}
                                    onChange={(e) =>
                                        setEmploiForm({ ...emploiForm, ville: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setEmploiStep(1)}>
                                        Retour
                                    </Button>
                                    <Button variant="contained" onClick={() => setEmploiStep(3)}>
                                        Suivant
                                    </Button>
                                </Box>
                            </>
                        )}

                        {/* ÉTAPE 3 */}
                        {emploiStep === 3 && (
                            <>
                                <TextField
                                    label="Sites utilisés"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    value={emploiForm.sites}
                                    onChange={(e) =>
                                        setEmploiForm({ ...emploiForm, sites: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setEmploiStep(2)}>
                                        Retour
                                    </Button>
                                    <Button variant="contained" onClick={() => setEmploiStep(4)}>
                                        Suivant
                                    </Button>
                                </Box>
                            </>
                        )}

                        {/* ÉTAPE 4 */}
                        {emploiStep === 4 && (
                            <>
                                <TextField
                                    label="Notes"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    value={emploiForm.notes}
                                    onChange={(e) =>
                                        setEmploiForm({ ...emploiForm, notes: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setEmploiStep(3)}>
                                        Retour
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={() => {
                                            setItems([
                                                ...items,
                                                {
                                                    id: Date.now(),
                                                    type: "emploi",
                                                    title: `${emploiForm.poste} - ${emploiForm.ville}`,
                                                    details: `Sites : ${emploiForm.sites}\n${emploiForm.notes}`,
                                                },
                                            ]);

                                            setEmploiForm({
                                                poste: "",
                                                ville: "",
                                                sites: "",
                                                notes: "",
                                            });

                                            setEmploiStep(1);
                                            setOpenEmploiDrawer(false);
                                        }}
                                    >
                                        Ajouter
                                    </Button>
                                </Box>
                            </>
                        )}
                    </Box>
                </Drawer>
            </ThemeProvider>

            <ThemeProvider theme={theme}>
                <Drawer
                    anchor="right"
                    open={openLogementDrawer}
                    onClose={() => {
                        setOpenLogementDrawer(false);
                        setLogementStep(1);
                    }}
                >
                    <Box
                        sx={{
                            width: "60vw",
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                        }}
                    >
                        <h2>Ajouter un logement</h2>

                        {logementStep === 1 && (
                            <>
                                <TextField
                                    label="Loyer estimé"
                                    type="number"
                                    fullWidth
                                    value={logementForm.loyer}
                                    onChange={(e) =>
                                        setLogementForm({ ...logementForm, loyer: e.target.value })
                                    }
                                />

                                <Button variant="contained" onClick={() => setLogementStep(2)}>
                                    Suivant
                                </Button>
                            </>
                        )}

                        {logementStep === 2 && (
                            <>
                                <TextField
                                    label="Ville ciblée"
                                    fullWidth
                                    value={logementForm.ville}
                                    onChange={(e) =>
                                        setLogementForm({ ...logementForm, ville: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setLogementStep(1)}>
                                        Retour
                                    </Button>
                                    <Button variant="contained" onClick={() => setLogementStep(3)}>
                                        Suivant
                                    </Button>
                                </Box>
                            </>
                        )}

                        {logementStep === 3 && (
                            <>
                                <TextField
                                    label="Type de logement"
                                    select
                                    fullWidth
                                    value={logementForm.type}
                                    onChange={(e) =>
                                        setLogementForm({ ...logementForm, type: e.target.value })
                                    }
                                >
                                    <MenuItem value="Appartement">Appartement</MenuItem>
                                    <MenuItem value="Maison">Maison</MenuItem>
                                    <MenuItem value="Studio">Studio</MenuItem>
                                    <MenuItem value="Colocation">Colocation</MenuItem>
                                </TextField>

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setLogementStep(2)}>
                                        Retour
                                    </Button>
                                    <Button variant="contained" onClick={() => setLogementStep(4)}>
                                        Suivant
                                    </Button>
                                </Box>
                            </>
                        )}

                        {logementStep === 4 && (
                            <>
                                <TextField
                                    label="Notes logement"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    value={logementForm.notes}
                                    onChange={(e) =>
                                        setLogementForm({ ...logementForm, notes: e.target.value })
                                    }
                                />

                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button variant="outlined" onClick={() => setLogementStep(3)}>
                                        Retour
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={() => {
                                            setItems([
                                                ...items,
                                                {
                                                    id: Date.now(),
                                                    type: "logement",
                                                    title: `${logementForm.type} - ${logementForm.ville}`,
                                                    details: `Loyer : ${logementForm.loyer} $/mois\n${logementForm.notes}`,
                                                },
                                            ]);

                                            setLogementForm({
                                                loyer: "",
                                                ville: "",
                                                type: "Appartement",
                                                notes: "",
                                            });

                                            setLogementStep(1);
                                            setOpenLogementDrawer(false);
                                        }}
                                    >
                                        Ajouter
                                    </Button>
                                </Box>
                            </>
                        )}
                    </Box>
                </Drawer>
            </ThemeProvider>


        </div>
    );
}
